import React from 'react';
import { Icons } from '@commercetools-docs/ui-kit';

// A React component to be rendered next to the microsite title
// eslint-disable-next-line react/display-name
export default () => {
  return <Icons.OpenSourceSmallSvgIcon />;
};
